export default "__VITE_ASSET__CCBJi6mx__"